<template>
    <div class="bg-white pt-6 shadow sm:rounded-md sm:overflow-hidden">
        <div class="px-4 sm:px-6">
            <h2 class="text-lg leading-6 font-medium text-gray-900">Details</h2>
        </div>
        <div class="mt-6 flex flex-col">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div class="overflow-hidden border-t border-gray-200">
                        <table class="min-w-full divide-y divide-gray-200">
                            <tbody class="bg-white divide-y divide-gray-200">
                            <tr>
                                <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Total Net Wt.
                                </td>
                                <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                    {{ outturn.net_pounds | numberInThousands  }}
                                </td>
                            </tr>
                            <tr>
                                <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Less Dedcutions
                                </td>
                                <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                    {{ outturn.foreign_matter_percent  }}%
                                </td>
                            </tr>
                            <tr>
                                <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Deduction Weight
                                </td>
                                <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                    {{ outturn.fm_pounds | numberInThousands }}
                                </td>
                            </tr>
                            <tr>
                                <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                    Net Clean Seed
                                </td>
                                <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                    {{ outturn.cleanseed | numberInThousands }}
                                </td>
                            </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        outturn: {
            type: Object,
            required: true,
            defualt: {}
        }
    },
}
</script>
